<template>
  <div>
    <SummaryHead summaryClass="-stereotype">
      <template v-slot:title01>{{pagetitle}}</template>
      <template v-slot:txt>
        「できる営業」と聞いてどんな人物をイメージしますか？<br>
        “社交的でコミュニケーション能力が高く、リーダーシップがある“という人物像は、皆さんがイメージする「できる営業像」とも近いのではないでしょうか。ハイパフォーマー特性の記事でも、成績上位層と中・下位層で人物特性に差があるのか調査した結果を紹介しました。<br>
        では、いわゆる「できる営業」の人物特性を持つ人は、どんな会社でも活躍することができるのでしょうか。保険と証券の「できる営業」を思い浮かべると、違う印象を持ちませんか？そんな各業界のハイパフォーマー特性の違いについてのぞいてみましょう。
      </template>
    </SummaryHead>

    <div class="contents-block">
      <section class="summary-section">

        <FadeInComponent>
        <h2 class="ttlbar -yellow _mw1000">ハイパフォーマーと成績中・下位層の差を比較</h2>
        </FadeInComponent>
        <div class="sminner">

          <FadeInComponent>
          <h3 class="smttlm -yellow _trgbtmct">この図は、中・下位層の外向性の平均を基準としたとき、<br>優秀層の平均点がどの程度離れているのかを表したものです。</h3>

          <div class="stereotype-exp">
            <div class="seinner">
              <div class="bln01">中・下位層平均</div>
              <div class="bln02">上位層平均</div>
              <img src="../assets/img/stereotype/man01.svg" alt="" class="man01">
              <img src="../assets/img/stereotype/man02.svg" alt="" class="man02">
              <div class="stnai">内向的</div>
              <div class="stgai">外向的</div>
            </div>
          </div>
          </FadeInComponent>

          <FadeInComponent>
          <div class="pncover -example">
            <div class="man01"><img src="../assets/img/stereotype/man01.svg" alt="" class="man01img"></div>
            <div class="man02"><img src="../assets/img/stereotype/man02.svg" alt="" class="man02img"></div>

            <div class="pncenter _trgbtmct -gray">
              中・下位層平均
            </div>
            <PosiNegaBar :pnbardata="pnbardata3"></PosiNegaBar>
            <div class="pnnai">内向的</div>
            <div class="pngai">外向的</div>
          </div>
          <p class="txt _mb70">
            優秀層は中・下位層と比べると、やや外交的な傾向があることが分かります。営業では顧客とのコミュニケーションが不可欠なため、納得のできる結果ではないでしょうか。
          </p>
          </FadeInComponent>

          <FadeInComponent>

          <h3 class="smttlm -yellow _trgbtmct">では、業界ごとに比較してみるとどうなるでしょうか。<br>こちらの図では、外向性における優秀層と中・下位層の差を業界ごとに表しています。</h3>
          <h4 class="smttls -gray">業界ごとに特性を比較</h4>
          <div class="pncover">
            <div class="pncenter _trgbtmct -gray">
              中・下位層平均
            </div>
            <PosiNegaBar :pnbardata="pnbardata2"></PosiNegaBar>
            <div class="pnnai">内向的</div>
            <div class="pngai">外向的</div>
          </div>
          </FadeInComponent>

          <FadeInComponent>

          <h4 class="smttls -gray">営業全体で比較した時と比べて、<br>自動車や保険業界では優秀層が極めて外向的な傾向があることが分かります。</h4>
          <p class="txt _mb40">これらのほかにも、業界別でみたときのほうが、より外向性の差が大きくなる業界が多くあります。</p>

          <h4 class="smttls -gray">一方で、証券や不動産業界では、小さな差ではありますが、<br>優秀層のほうが中・下位層よりもやや内向的である、ということが読み取れます。</h4>
          <p class="txt _mb40">商材の価格変動が特に大きなこの業界では、社交性やコミュニケーション能力といった外に向いた力だけでなく、顧客の状況を熟考したり慎重に提案内容を精査したりするような内に向いた力がより重要であることを示唆しているといえます。</p>

          <h3 class="smttlm -yellow _trgbtmct">このように、「できる営業」の能力は普遍的なものではありません。<br>商材や営業手法が異なれば、もちろん求められるセールスパーソン像も異なります。</h3>
          <p class="txt _mb80">置かれた環境で成果をあげるためには、「営業は人とかかわる仕事だから、外向的であれば外向的なほど良い！」というような思い込みを捨て、業界のカラーと人物特性を慎重に見極めることが重要となります。</p>
          </FadeInComponent>

        </div><!-- .sminner -->

        <SummaryBottom :bgColor="2"></SummaryBottom>

      </section>

      <RelatedContents :contentsNum="2"></RelatedContents>
    </div><!-- contents-block -->
  </div>
</template>

<script>
import SummaryHead from "../components/SummaryHead.vue";
import SummaryBottom from "../components/SummaryBottom.vue";

import PosiNegaBar from "../components/PosiNegaBar.vue";
import RelatedContents from "../components/RelatedContents.vue";
import FadeInComponent from "../components/FadeInComponent.vue";


export default {
  components: {
    PosiNegaBar,
    RelatedContents,
    SummaryHead,
    SummaryBottom,
    FadeInComponent

  },
  data() {
    return {
      pagetitle:"「できる営業像」の思い込み",
      pnbardata2: [
        { num: 0, name: "全体", val: 2, img:null },
        { num: 1, name: "IT", val: 3, img:"-it"},
        { num: 2, name: "製薬(MR)", val: 2, img:"-mr"},
        { num: 3, name: "銀行", val: 4, img:"-bank"},
        { num: 4, name: "自動車ディーラー", val: 5, img:"-cardealer"},
        { num: 5, name: "商社", val: 1, img:"-shosha"},
        { num: 6, name: "証券", val: -1, img:"-securities"},
        { num: 7, name: "食品メーカー", val: 2, img:"-foodcompany"},
        { num: 8, name: "人材", val: 2, img:"-staffagency"},
        { num: 9, name: "不動産", val: -2, img:"-estate"},
        { num: 10, name: "保険", val: 5, img:"-insurance"},
      ],
      pnbardata3: [
        { num: 0, name: null, val: 2, img:null },
      ],      
    };
  },
  metaInfo: {
    title: "「できる営業像」の思い込み | 人気10業界！営業職の特徴を人物特性からのぞいてみた",
    titleTemplate: "%s | SALES SCOPE",
    htmlAttrs: {
      lang: "jp",
    },
  },
  mounted: function(){
    document.querySelector("meta[name='description']").setAttribute('content', "優秀層(ハイパフォーマー)と中・下位層のセールスパーソンの差を比較。「できる営業」と聞いてどんな人物をイメージしますか？保険と証券の「できる営業」を思い浮かべると、違う印象を持ちませんか？そんな各業界のハイパフォーマー特性の違いについてのぞいてみましょう。");
  }  

};
</script>